import { render, staticRenderFns } from "./TransferReport.vue?vue&type=template&id=07cda724&"
import script from "./TransferReport.vue?vue&type=script&lang=js&"
export * from "./TransferReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports